module.exports = __webpack_public_path__ + "static/media/aETH-logo.c24821a4.png";